import { Component } from '@angular/core';
export class TestModalComponent {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  template: '<div id="test-modal-component"><h1>Test modal component</h1></div>'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TestModalComponent_tsickle_Closure_declarations() {
/** @type {?} */
TestModalComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TestModalComponent.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
